export default __webpack_public_path__ + "static/media/01-imagen-sala-1.f01ab08f.jpg";